import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { StayTunedMessage } from 'src/core';
import { ErrorView, changeLanguage, loadTranslation, loginRequest } from 'src/shared';
import { useEffect, useState } from 'react';
import { ApiError, MeService } from 'src/apis/api-client';
import { FlowsRouter } from 'src/domains/flows';
import { useMsal } from '@azure/msal-react';
import { AppRedirectView } from 'src/domains/app-redirect';
import { JoinView, NotPossibleView } from 'src/domains/programs/views/join';

export function CoreRouter() {

  const [ notified, setNotified ] = useState<boolean>(false);
  const [ error, setError ] = useState<boolean>(false);
  const [ errorObj, setErrorObj ] = useState<any>();

  const navigate = useNavigate();
  const msalInstance = useMsal();

  /**
   * Calls the UserService getMe method.
   * This will create the user if it doesn't exist in the database.
   * Also, during this operation, the referrals will get auto assigned.
   */
  useEffect(
    () => {
      (
        async () => {
          try {
            const val = await MeService.getMe();
            if (val) {
              await loadTranslation();
              setNotified(true);

              // Change the language based on the profile setting.
              if (val.languageCode) {
                changeLanguage(val.languageCode);
              }

              // If not on a PDJ flow or join URL, send to the app redirect screen.
              if (
                !window.location.pathname.startsWith('/flows') &&
                !window.location.pathname.startsWith('/programs')
              ) {
                navigate('/app', { replace: true });
              }
            } else {
              setError(true);
              setErrorObj({ message: `Couldn't get UsersMeResponse.` });
            }
          } catch (error: any) {
            /**
             * Should be a fix for the following problem:
             * https://github.com/AzureAD/microsoft-authentication-library-for-js/issues/349
             */
            if (
              error &&
              error.errorCode === 'interaction_required'
            ) {
              await msalInstance.instance.loginRedirect(loginRequest);
              return;
            }

            if (error instanceof ApiError) {
              if (error.status !== 400 && error.status !== 401) {
                setError(true);
              }
            } else {
              setError(true);
            }

            setErrorObj(error);
          }
        }
      )();
    },
    []
  );

  return (
    notified
      ? <Routes>
          <Route path='/flows/*' element={<FlowsRouter />} />
          <Route path='/programs/:programId/join' element={<JoinView />} />
          <Route path='/programs/sorry/:reason' element={<NotPossibleView />} />
          <Route path='/app' element={<AppRedirectView />} />
          <Route path='/' element={<Navigate to='/app' replace />} />

          <Route path='404' element={<ErrorView />} />
          <Route path='*' element={<Navigate to='/404' replace />} />
        </Routes>
      : error
        ? <ErrorView error={errorObj} />
        : <StayTunedMessage />
  );
}

export default CoreRouter;
